import 'angular';
import './approver_in_level_display.html';

import '../approverEntry/approverEntry';
import {ApprovalStatus} from '../../approvals-types'
import {IApprovalUtils} from '../../ApprovalUtils';

angular.module('GorillaBoy.Approvals')
    .directive('approverInLevelDisplay', ['$translate', 'ApprovalUtils', ($translate: ng.translate.ITranslateService, ApprovalUtils: IApprovalUtils) => {
        return {
            restrict: 'E',
            scope: {
                levelConfig: '<',
                isOpen: '<'
            },
            templateUrl: './approvals/approvalView/approverInLevelDisplay/approver_in_level_display.html',
            link: function($scope, $element, attrs) {
                $scope.isLevelMemberVisible = !!$scope.isOpen;

                $scope.toggleLevelMemberVisibility = () => {
                    $scope.isLevelMemberVisible = !$scope.isLevelMemberVisible;
                }

                $scope.getApprovalStatusText = ApprovalUtils.getApprovalStatusText;

                $scope.getApprovalStatusIndicator = ApprovalUtils.getApprovalStatusIndicator;
            }
        };
    }]);